import { Language, ErrorGeneratorConfig } from '../types';

import formatTime from './formatTime';

export const errorGenerator = (config: ErrorGeneratorConfig) => {
	switch (config.language) {
		case Language.He:
			return config.heError;
		case Language.En:
			return config.enError;
		default:
			throw new Error();
	}
}


// a small upgrade to the `translate` function --> allows to replace parts of the string with parameters from the array passed to this function
// (similar to sql query parameters array)
// e.g. value: "name must contain at least {?} characters" ; params: [20] => results in: "name must contain at least 20 characters"

export const greaterThan = (language: Language, name: string, limit: number) => errorGenerator({
	language,
	heError: `{?} צריך להכיל לפחות {?} תווים`,
	enError: `The {?} must be at least {?} characters long`
});

export const smallerThan = (language: Language, name: string, limit: number) => errorGenerator({
	language,
	heError: `{?} יכול להכיל עד {?} תווים`,
	enError: `The {?} only be up to {?} characters long`
});

export const length = (language: Language, name: string, limit: number) => errorGenerator({
	language,
	heError: `{?} צריך להכיל {?} תווים בדיוק`,
	enError: `The {?} must be {?} characters long`
});

export const regex = (language: Language, name?: string, error?: string) => errorGenerator({
	language,
	heError: `${name || 'שדה זה'} ${error || 'אינו תקין'}`,
	enError: `${name ? `The ${name}` : 'This field'} ${error && 'is invalid'}`
});

export const required = (language: Language) => errorGenerator({
	language,
	heError: 'שדה זה הינו חובה',
	enError: 'This field is required'
});

export const confirm = (language: Language) => errorGenerator({
	language,
	heError: 'השדות אינם זהים',
	enError: 'The fields do not match'
});

export const image = (language: Language) => errorGenerator({
	language,
	heError: 'סוג הקובץ אינו תקין',
	enError: 'Invalid file type'
});

export const dateBefore = (language: Language, date: Date) => errorGenerator({
	language,
	heError: `התאריך שהוזן צריך להיות לפני {?}`,
	enError: `The entered date must be before {?}`
});

export const dateAfter = (language: Language, date: Date) => errorGenerator({
	language,
	heError: `התאריך שהוזן צריך להיות אחרי {?}`,
	enError: `The entered date must be after {?}`
});

export const timeBefore = (language: Language, date: Date) => errorGenerator({
	language,
	heError: `הזמן שהוזן צריך להיות לפני {?}`,
	enError: `The entered time must be before {?}`
});

export const timeAfter = (language: Language, date: Date) => errorGenerator({
	language,
	heError: `הזמן שהוזן צריך להיות אחרי {?}`,
	enError: `The entered time must be after {?}`
});

export const fileNameLength = (language: Language) => errorGenerator({
	language,
	heError: 'שם הקובץ ארוך מדי',
	enError: 'The name of the file is too long'
});